/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { ZLOOnboardingPreviewTable } from '../../PreviewTable/PreviewTable';
import _ from 'lodash';
import { Button, Icon } from '@scuf/common';

import './PreviewTabTheme.scss';

type IDescriptorProcessedMessages = string;

interface IZLOPreviewTabProps {
  validatedData: any[];
  errorMessages: IDescriptorProcessedMessages[];
  allValid: boolean;
  numErrors: number;
}

const PreviewTab: React.FC<IZLOPreviewTabProps> = (
  props: IZLOPreviewTabProps
) => {
  const { validatedData, errorMessages, allValid, numErrors } = props;

  const [t] = useTranslation();
  const z = descriptors.ZLOOnboardingConfig;
  const [showTable, setShowTable] = useState(false);

  return (
    <div className="preview-tab-wrapper">
      {errorMessages.length > 0 ? (
        <>
          <div className="validation-error-wrapper">
            <div className="valid-error-icon-wrapper">
              <Icon
                root="common"
                className="valid-error-icon"
                name="badge-important"
              />
            </div>
            <div className="valid-error-title">
              {t(z.VALIDATION_ERROR_TITLE)}
            </div>
            <hr className="hr-width valid-error-divider" />
            <div className="valid-error-details">
              {_.map(errorMessages, (m, i) => (
                <div key={`err-msg-${i}`}>{m}</div>
              ))}
            </div>
          </div>
        </>
      ) : allValid && !showTable ? (
        <>
          <div className="validation-success-wrapper">
            <div className="all-valid-icon-wrapper">
              <Icon
                root="common"
                className="all-valid-check-icon"
                name="badge-check"
              />
            </div>
            <div className="valid-success-title">{t(z.ALL_ENTRIES_VALID)}</div>
            <hr className="hr-width valid-success-divider" />
            <div className="valid-success-subtitle">
              {t(z.SUBMIT_TO_PROCEED_SUBTEXT)}
            </div>
            <Button
              type="link"
              className="show-all-button"
              content={t(z.VIEW_ALL_ENTRIES)}
              onClick={() => setShowTable(true)}
            />
          </div>
        </>
      ) : (
        <ZLOOnboardingPreviewTable
          numErrors={numErrors}
          validatedData={validatedData}
          pagination={true}
        />
      )}
    </div>
  );
};

export default PreviewTab;
